export default __webpack_public_path__ + "static/economy1-ab7fd52d66d28d6225fd787ff4d29b17.png";